import React, {
  type ChangeEvent,
  forwardRef,
  type InputHTMLAttributes,
  type Ref,
  useEffect,
} from "react";
import { CloseCircle, MagnifyingGlass } from "../icons";
import { Input } from "./Input";
import styles from "./SearchInput.module.css";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  ref?: Ref<HTMLInputElement>;
  disabled?: boolean;
  error?: string;
  onClickClear?: () => void;
  fullWidth?: boolean;
}

export const SearchInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      value,
      onClickClear,
      onChange,
      fullWidth,
      autoFocus,
      ...rest
    }: InputProps,
    ref
  ) => {
    const [isEmpty, setIsEmpty] = React.useState(true);
    const shouldShowClear = !!value || !isEmpty;
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e);
      setIsEmpty(!e.target.value);
    };
    useEffect(() => {
      setIsEmpty(!value);
    }, [value]);
    return (
      <Input
        autoFocus={autoFocus}
        leftIcon={<MagnifyingGlass />}
        rightIcon={shouldShowClear ? <CloseCircle /> : undefined}
        value={value}
        onClickRightIcon={() => onClickClear?.()}
        onChange={handleChange}
        fullWidth={fullWidth}
        className={`${!fullWidth ? styles.search : ""}`}
        ref={ref}
        {...rest}
      />
    );
  }
);

SearchInput.displayName = "SearchInput";
